import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { experimentRunQuery } from '@/features/ml/experiments/experiment-api';
import { isExperimentRunTab, type ExperimentRunTab } from '@/features/ml/experiments/experiment-tabs';
import { RunDetailPage } from '@/features/ml/experiments/run-detail-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un run d'expérience (porting README #82). L'onglet actif vit dans l'URL (`?tab=params`). */
export const Route = createFileRoute('/$tenant/projects/$projectId/experiments/$experimentId/runs/$runId')({
  validateSearch: (search: Record<string, unknown>): { tab: ExperimentRunTab } => ({
    tab: isExperimentRunTab(search['tab']) ? search['tab'] : 'metrics',
  }),
  component: ExperimentRunRoute,
});

function ExperimentRunRoute() {
  const { tenant, projectId, experimentId, runId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  const run = useQuery(experimentRunQuery(tenant, projectId, experimentId, runId));
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="experiments"
      // Deux niveaux seulement : trois (dont un nom de run en chasse fixe) débordent de la barre
      // supérieure à 1440 px. L'expérience est nommée par le lien de retour et le sous-titre.
      crumbs={[{ label: t('nav.items.experiments') }, { label: run.data?.name ?? runId, mono: true }]}
    >
      <RunDetailPage
        tenantId={tenant}
        projectId={projectId}
        experimentId={experimentId}
        runId={runId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
